export const APPEARANCE_COOKIE_NAME = 'canis_theme'

export const APPEARANCE_OPTIONS = ['light', 'dark', 'system']

export const appearanceCookieOptions = {
  default: () => 'light',
  maxAge: 60 * 60 * 24 * 365,
  path: '/',
  sameSite: 'lax',
}

export const normalizeAppearance = (value) => {
  return APPEARANCE_OPTIONS.includes(value) ? value : 'light'
}
